import apiClient from '../api/client/axios.config';
import { API_ENDPOINTS } from '../api/endpoints';

export const authService = {
    login: async (data) => await apiClient.post(API_ENDPOINTS.AUTH.LOGIN, data),
    register: async (data) => await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, data),
    logout: async () => await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT),
    forgotPassword: async (data) => await apiClient.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, data),
};
